import { useEffect, useState, useRef } from 'react';
import './ResearchGroupInfo.css';
import ReactMarkdown from 'react-markdown';
import InfoPageFrame from './InfoPageFrame';
import ImageCarousel from './ImageCarousel';

export default function ResearchGroupInfo(props) {

    const [ groupData, setGroupData] = useState(null);
    const [ description, setDescription] = useState("");
    const [ results, setResults] = useState("");
    const [ people, setPeople ] = useState([]);
    const carousel = useRef(null);

    useEffect(() => {
        if (groupData) {    
            if (groupData.description.slice(0, 5) === "file:")
                fetch(`./data/${groupData.description.slice(5)}`)
                    .then((res) => res.text())
                    .then((md) => setDescription(md));
            else
                setDescription(groupData.description);
            if (groupData.results.slice(0, 5) === "file:")
                fetch(`./data/${groupData.results.slice(5)}`)
                    .then((res) => res.text())
                    .then((md) => setResults(md));
            else
                setResults(groupData.results);
            setPeople(groupData.staff.map(s => Object.assign(s, window.people.find(p => s.mtmt.length > 0 ? p.MTMT === s.mtmt : p["Név"] === s.name))));            
            if (carousel.current)
                carousel.current.moveTo(0);
        }
    }, [groupData]);

    const leaders = groupData ? groupData.leader.filter(d => people.find(e => e.name === d)).map(d => people.find(e => e.name === d)) : [];   

    return <InfoPageFrame 
        file={`./data/${props.file}`}
        name={groupData?.name}
        logo={groupData?.logo}
        keywords={groupData?.keywords}
        leaders={leaders}
        presence={groupData?.presence}
        lang={props.lang}
        onPageDataLoaded={dta => setGroupData(dta)}
        staff={people}>
            {groupData && <>
                <ImageCarousel carouselRef={carousel} imageList={groupData.images} />
                <div className="section-title">
                    {props.lang === "hu" ? "A kutatócsoport tevékenysége:" : "Activity of the research group:"}
                </div>
                <ReactMarkdown>
                    {description}
                </ReactMarkdown>
                <div className="section-title">
                    {props.lang === "hu" ? "Eredmények:" : "Recent results:"}
                </div>
                <ReactMarkdown>
                    {results}
                </ReactMarkdown>
                {groupData.infrastructure && groupData.infrastructure.length > 0 && <><div className="section-title">
                        {props.lang === "hu" ? "Speciális infrastruktúra:" : "Special infrastructure:"}
                    </div>
                        {groupData.infrastructure.join(" • ")}
                    </>}
                {groupData.projects && groupData.projects.length > 0 && <><div className="section-title">
                        {props.lang === "hu" ? "A közelmúlt projektjei:" : "Recent projects:"}
                    </div>
                        {groupData.projects.join(" • ")}
                </>}
                {groupData.international && groupData.international.length > 0 && <><div className="section-title">
                        {props.lang === "hu" ? "Nemzetközi kapcsolatok:" : "International relations:"}
                    </div>
                        {groupData.international.join(" • ")}
                    </>}
                {groupData.partners && groupData.partners.length > 0 && <><div className="section-title">
                        {props.lang === "hu" ? "Vállalati partnerek:" : "Industrial partners:"}
                    </div>
                        {groupData.partners.join(" • ")}
                </>}
            </>}
        </InfoPageFrame>;
}
